export default __webpack_public_path__ + "static/media/car-active.a27e745e.svg";